import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private keycloak = inject(Keycloak);
  private router = inject(Router);
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const requiredRoles = route.data['roles'];

    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }
    const hasRole = requiredRoles.some((role: string) => this.keycloak.hasResourceRole(role));

    if (!hasRole) {
      if (route.routeConfig?.path === '') {
        const redirected = this.authService.redirectToFirstAccessibleRoute();
        if (redirected) {
          return false;
        } else {
          this.router.navigate(['/access-denied']);
          return false;
        }
      }

      const accessibleRoutes = this.authService.getAccessibleRoutes();
      if (accessibleRoutes.length > 0) {
        this.authService.redirectToFirstAccessibleRoute();
      } else {
        this.router.navigate(['/access-denied']);
      }

      return false;
    }

    return true;
  }
}
